import { render } from "./imageOnly.vue?vue&type=template&id=318b25fb&scoped=true"
import script from "./imageOnly.vue?vue&type=script&lang=js"
export * from "./imageOnly.vue?vue&type=script&lang=js"

import "./imageOnly.vue?vue&type=style&index=0&id=318b25fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318b25fb"]])

export default __exports__